import { useQuery } from "@apollo/client";
import { ProfileContactView } from "./profile-contact-view";
import { ApplicantProfileContactContainerApplicantUserDocument } from "../../../../generated";
import { Empty, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import { ComponentQueryLoader } from "../../../shared/component-query-loader";
import { getItem } from "../../../shared/local-storage";

export const ProfileContactViewContainer = () => {
  const navigate = useNavigate();
  const applicantUserId = getItem('applicantUserId');

  const {
    data: contactData,
    loading: contactLoading,
    error: contactError,
  } = useQuery(ApplicantProfileContactContainerApplicantUserDocument, {
    variables: {
      applicantUserId,
    },
  });

  const handleEdit = () => {
    const currentPath = location.pathname;
    const newPath = currentPath.replace(/\/[^/]+$/, "/edit");
    navigate(newPath);
  };

  if (contactLoading) {
    return <Skeleton active />;
  }

  if (
    contactError ||
    !contactData?.applicantUser?.personalInformation?.contactInformation
  ) {
    return (
      <Empty description="There was an error loading the data. Please try again!" />
    );
  }

  return (
    <ComponentQueryLoader
      error={contactError}
      loading={contactLoading}
      hasData={true}
      hasDataComponent={
        <ProfileContactView
          contactInformation={
            contactData.applicantUser.personalInformation.contactInformation
          }
          onEdit={handleEdit}
        />
      }
    />
  );
};
